<template>
  <div class="w-100 py-3 px-4 bg-top-lublin start-header">
    <div class="d-flex container p-0">
      <div class="page-logo width-mobile-auto m-0 p-0 bg-transparent bg-img-none shadow-0 height-9">
        <a href="https://lublin.eu" target="_blank" class="page-logo-link press-scale-down" aria-label="Otwarcie w nowej karcie: strona lublin.eu">
          <img src="/img/logo_lublin.svg" aria-roledescription="logo" alt="Logo miasta Lublin" />
        </a>
      </div>

      <div class="page-logo width-mobile-auto m-0 p-0 bg-transparent bg-img-none shadow-0 height-9">
        <a href="https://edu.lublin.eu" target="_blank" class="page-logo-link press-scale-down" aria-label="Otwarcie w nowej karcie: strona edu.lublin.eu">
          <img src="/img/logo_edu_lublin.svg" aria-roledescription="logo" alt="Logo miasta Lublin" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/utils/config';

// @vuese
// Nagłówek dla niezalogowanego użytkownika
// @group StartLayout
export default {
  name: 'Header',
  computed: {
    loginEnabled() {
      return !config.loginDisabled;
    }
  }
};
</script>

<style scoped>
.bg-top-lublin {
  background-color: white !important;
  border-bottom: 3px solid red !important;
}
.btn.btn-primary {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
}

.start-header .page-logo img {
  max-height: 4rem;
}

.start-header .container {
  justify-content: space-between;
}
</style>
